/**
 * Adiar o aviso de segundo fator (B15).
 *
 * ── Por que existe um "agora não" ─────────────────────────────────────────
 *
 * O aviso é um empurrão, não um bloqueio. Sem saída, quem está no meio de um
 * atendimento e não pode parar para cadastrar aprende a ignorá-lo — e um aviso
 * ignorado não protege ninguém. Pior: ele ensina a ignorar os OUTROS avisos,
 * porque a faixa amarela no topo passa a ser paisagem.
 *
 * Uma semana é longa o bastante para não incomodar e curta o bastante para
 * voltar antes de a pessoa esquecer que existe.
 *
 * ── O adiamento NÃO é o fim do aviso ──────────────────────────────────────
 *
 * Ele volta. O que faz o aviso sumir de vez é o segundo fator existir — e isso
 * quem responde é o provedor de identidade, não este arquivo. Guardar aqui um
 * "já cadastrou" seria criar uma segunda verdade, que é exatamente o defeito
 * que este aviso teve: ele lia o `amr` do token e continuava aparecendo depois
 * de a pessoa cadastrar.
 */

const CHAVE = 'cliqcrm:aviso-de-segundo-fator-ate';

/** Uma semana. */
const ADIAMENTO_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Até quando o aviso está adiado, em epoch. `0` = não está.
 *
 * Falha de leitura devolve `0` — o aviso aparece. `localStorage` estoura em
 * navegação anônima de alguns navegadores, e a resposta segura aqui é mostrar:
 * esconder um aviso de segurança por causa de um erro de armazenamento seria
 * errar para o lado que custa caro.
 */
export function lerAdiamentoDoAviso(
  deposito: Storage | undefined = globalThis.localStorage,
  agora: number = Date.now(),
): number {
  try {
    const bruto = deposito?.getItem(CHAVE);
    if (!bruto) return 0;
    const ate = Number(bruto);
    if (!Number.isFinite(ate) || ate <= 0) return 0;
    /*
     * Adiamento absurdamente longo é descartado.
     *
     * Ele só aparece por relógio errado na máquina ou por alguém editando o
     * armazenamento — e um valor de 2099 silenciaria o aviso para sempre, sem
     * ninguém nunca descobrir por quê.
     */
    if (ate > agora + ADIAMENTO_MS) return 0;
    return ate;
  } catch {
    return 0;
  }
}

/** Adia por uma semana e devolve até quando. */
export function adiarAviso(
  deposito: Storage | undefined = globalThis.localStorage,
  agora: number = Date.now(),
): number {
  const ate = agora + ADIAMENTO_MS;
  try {
    deposito?.setItem(CHAVE, String(ate));
  } catch {
    // Sem onde guardar, o adiamento vale só para esta aba — o estado em
    // memória de quem chamou já foi atualizado. Some no recarregamento, e
    // é melhor que estourar.
  }
  return ate;
}
